// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  padding: 20px;
  color: white;
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Custom styles for the internship platform */
.min-h-screen {
  min-height: 100vh;
}

.shadow-xl {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

/* Enhanced Navigation Styles */
.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

/* Navigation button animations */
.nav-button {
  transition: all 0.3s ease;
}

.nav-button:hover {
  transform: translateY(-2px);
}

.nav-button:active {
  transform: translateY(0);
}

/* Enhanced focus styles for accessibility */
.nav-button:focus {
  outline: 2px solid #fff;
  outline-offset: 2px;
}

/* Badge styles for notifications */
.notification-badge {
  position: relative;
}

.notification-badge::after {
  content: '';
  position: absolute;
  top: -2px;
  right: -2px;
  width: 8px;
  height: 8px;
  background-color: #ef4444;
  border-radius: 50%;
  border: 2px solid #fff;
}

/* Improved typography */
.nav-label {
  font-weight: 500;
  letter-spacing: 0.025em;
}

/* Responsive improvements */
@media (max-width: 640px) {
  .nav-container {
    padding: 0.5rem;
  }
  
  .nav-button {
    padding: 0.5rem;
    min-width: 44px; /* Minimum touch target size */
  }
}

.focus\\:ring-blue-500:focus {
  --tw-ring-color: #3b82f6;
}

.focus\\:border-blue-500:focus {
  border-color: #3b82f6;
}

/* Gradient backgrounds */
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}

.from-blue-50 {
  --tw-gradient-from: #eff6ff;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(239, 246, 255, 0));
}

.to-indigo-100 {
  --tw-gradient-to: #e0e7ff;
}

/* Custom button hover effects */
.hover\\:bg-blue-700:hover {
  background-color: #1d4ed8;
}

.hover\\:bg-red-700:hover {
  background-color: #b91c1c;
}

.hover\\:bg-green-700:hover {
  background-color: #15803d;
}

/* Status badges */
.bg-yellow-100 {
  background-color: #fef3c7;
}

.text-yellow-800 {
  color: #92400e;
}

.bg-green-100 {
  background-color: #dcfce7;
}

.text-green-800 {
  color: #166534;
}

.bg-red-100 {
  background-color: #fee2e2;
}

.text-red-800 {
  color: #991b1b;
}

.bg-blue-100 {
  background-color: #dbeafe;
}

.text-blue-800 {
  color: #1e40af;
}

/* Navigation styles */
.border-b-2 {
  border-bottom-width: 2px;
}

.border-transparent {
  border-color: transparent;
}

.border-white {
  border-color: #ffffff;
}

.text-blue-100 {
  color: #dbeafe;
}

.hover\\:border-blue-300:hover {
  border-color: #93c5fd;
}

/* Grid layouts */
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

@media (min-width: 768px) {
  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1024px) {
  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

/* Spacing utilities */
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  margin-top: 1.5rem;
}

.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  margin-top: 1rem;
}

.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  margin-left: 1rem;
}

.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  margin-left: 0.5rem;
}

/* Flex utilities */
.flex-wrap {
  flex-wrap: wrap;
}

.items-start {
  align-items: flex-start;
}

.items-end {
  align-items: flex-end;
}

.justify-between {
  justify-content: space-between;
}

/* Text utilities */
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}

.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}

.font-semibold {
  font-weight: 600;
}

/* Responsive utilities */
@media (min-width: 640px) {
  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

@media (min-width: 1024px) {
  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Loading animation */
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: .5;
  }
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

/* Form styles */
.focus\\:ring-2:focus {
  --tw-ring-width: 2px;
}

.focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

/* Card hover effects */
.hover\\:shadow-lg:hover {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

/* Transition effects */
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

/* Mobile responsive */
@media (max-width: 640px) {
  .text-2xl {
    font-size: 1.25rem;
  }
  
  .text-xl {
    font-size: 1.125rem;
  }
  
  .px-8 {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,8CAA8C;AAC9C;EACE,iBAAiB;AACnB;;AAEA;EACE,qFAAqF;AACvF;;AAEA,+BAA+B;AAC/B;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,4CAA4C;AAC5C;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe,EAAE,8BAA8B;EACjD;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,4EAA4E;AAC9E;;AAEA;EACE,2BAA2B;EAC3B,2FAA2F;AAC7F;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,gDAAgD;AAClD;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE;IACE,oBAAoB;IACpB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE,yDAAyD;AAC3D;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,mFAAmF;AACrF;;AAEA,uBAAuB;AACvB;EACE,wBAAwB;EACxB,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  padding: 20px;\n  color: white;\n  min-height: 50vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Custom styles for the internship platform */\n.min-h-screen {\n  min-height: 100vh;\n}\n\n.shadow-xl {\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n}\n\n/* Enhanced Navigation Styles */\n.scrollbar-hide {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n.scrollbar-hide::-webkit-scrollbar {\n  display: none;\n}\n\n/* Navigation button animations */\n.nav-button {\n  transition: all 0.3s ease;\n}\n\n.nav-button:hover {\n  transform: translateY(-2px);\n}\n\n.nav-button:active {\n  transform: translateY(0);\n}\n\n/* Enhanced focus styles for accessibility */\n.nav-button:focus {\n  outline: 2px solid #fff;\n  outline-offset: 2px;\n}\n\n/* Badge styles for notifications */\n.notification-badge {\n  position: relative;\n}\n\n.notification-badge::after {\n  content: '';\n  position: absolute;\n  top: -2px;\n  right: -2px;\n  width: 8px;\n  height: 8px;\n  background-color: #ef4444;\n  border-radius: 50%;\n  border: 2px solid #fff;\n}\n\n/* Improved typography */\n.nav-label {\n  font-weight: 500;\n  letter-spacing: 0.025em;\n}\n\n/* Responsive improvements */\n@media (max-width: 640px) {\n  .nav-container {\n    padding: 0.5rem;\n  }\n  \n  .nav-button {\n    padding: 0.5rem;\n    min-width: 44px; /* Minimum touch target size */\n  }\n}\n\n.focus\\:ring-blue-500:focus {\n  --tw-ring-color: #3b82f6;\n}\n\n.focus\\:border-blue-500:focus {\n  border-color: #3b82f6;\n}\n\n/* Gradient backgrounds */\n.bg-gradient-to-br {\n  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));\n}\n\n.from-blue-50 {\n  --tw-gradient-from: #eff6ff;\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(239, 246, 255, 0));\n}\n\n.to-indigo-100 {\n  --tw-gradient-to: #e0e7ff;\n}\n\n/* Custom button hover effects */\n.hover\\:bg-blue-700:hover {\n  background-color: #1d4ed8;\n}\n\n.hover\\:bg-red-700:hover {\n  background-color: #b91c1c;\n}\n\n.hover\\:bg-green-700:hover {\n  background-color: #15803d;\n}\n\n/* Status badges */\n.bg-yellow-100 {\n  background-color: #fef3c7;\n}\n\n.text-yellow-800 {\n  color: #92400e;\n}\n\n.bg-green-100 {\n  background-color: #dcfce7;\n}\n\n.text-green-800 {\n  color: #166534;\n}\n\n.bg-red-100 {\n  background-color: #fee2e2;\n}\n\n.text-red-800 {\n  color: #991b1b;\n}\n\n.bg-blue-100 {\n  background-color: #dbeafe;\n}\n\n.text-blue-800 {\n  color: #1e40af;\n}\n\n/* Navigation styles */\n.border-b-2 {\n  border-bottom-width: 2px;\n}\n\n.border-transparent {\n  border-color: transparent;\n}\n\n.border-white {\n  border-color: #ffffff;\n}\n\n.text-blue-100 {\n  color: #dbeafe;\n}\n\n.hover\\:border-blue-300:hover {\n  border-color: #93c5fd;\n}\n\n/* Grid layouts */\n.grid-cols-1 {\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n}\n\n@media (min-width: 768px) {\n  .md\\:grid-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 1024px) {\n  .lg\\:grid-cols-4 {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n}\n\n/* Spacing utilities */\n.space-y-6 > :not([hidden]) ~ :not([hidden]) {\n  margin-top: 1.5rem;\n}\n\n.space-y-4 > :not([hidden]) ~ :not([hidden]) {\n  margin-top: 1rem;\n}\n\n.space-x-4 > :not([hidden]) ~ :not([hidden]) {\n  margin-left: 1rem;\n}\n\n.space-x-2 > :not([hidden]) ~ :not([hidden]) {\n  margin-left: 0.5rem;\n}\n\n/* Flex utilities */\n.flex-wrap {\n  flex-wrap: wrap;\n}\n\n.items-start {\n  align-items: flex-start;\n}\n\n.items-end {\n  align-items: flex-end;\n}\n\n.justify-between {\n  justify-content: space-between;\n}\n\n/* Text utilities */\n.text-xs {\n  font-size: 0.75rem;\n  line-height: 1rem;\n}\n\n.text-2xl {\n  font-size: 1.5rem;\n  line-height: 2rem;\n}\n\n.font-semibold {\n  font-weight: 600;\n}\n\n/* Responsive utilities */\n@media (min-width: 640px) {\n  .sm\\:px-6 {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n}\n\n@media (min-width: 1024px) {\n  .lg\\:px-8 {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n}\n\n/* Custom scrollbar */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n/* Loading animation */\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: .5;\n  }\n}\n\n.animate-pulse {\n  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n/* Form styles */\n.focus\\:ring-2:focus {\n  --tw-ring-width: 2px;\n}\n\n.focus\\:ring-offset-2:focus {\n  --tw-ring-offset-width: 2px;\n}\n\n.disabled\\:opacity-50:disabled {\n  opacity: 0.5;\n}\n\n/* Card hover effects */\n.hover\\:shadow-lg:hover {\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n}\n\n/* Transition effects */\n.transition-all {\n  transition-property: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\n/* Mobile responsive */\n@media (max-width: 640px) {\n  .text-2xl {\n    font-size: 1.25rem;\n  }\n  \n  .text-xl {\n    font-size: 1.125rem;\n  }\n  \n  .px-8 {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
